import { useTheme } from "styled-components";
import React, { useMemo } from "react";
import { Cell, Legend, Pie, PieChart as RechartsPieChart, ResponsiveContainer } from "recharts";
import { Tooltip } from "../Tooltip";
import { Box } from "../Box";
import { EmptyChart } from "./EmptyChart";
import { PopoverContents } from "./internal/PopoverContents";
import { doesPieChartHaveData, formattedLegendText, getDataFillColor, TRANSLATERISKS, } from "./helpers";
export const PieChart = ({ cursor, cx, cy, data, emptyMessage, emptyMessageFontSize, endAngle, innerRadius = 0, isAnimationActive, isRiskChart, noLegend, outerRadius = "80%", popoverContentsColumns = [], responsiveContainerHeight = "100%", responsiveContainerWidth = "100%", showPopover = true, startAngle, tooltip, }) => {
    const theme = useTheme();
    const { colors: { chartColors }, } = theme;
    const pieChartHasData = useMemo(() => (data === null || data === void 0 ? void 0 : data.length) && doesPieChartHaveData(data), [data]);
    // Sort
    if (pieChartHasData) {
        if (isRiskChart) {
            data.sort((a, b) => TRANSLATERISKS[b.name] - TRANSLATERISKS[a.name]);
        }
        else {
            data.sort((a, b) => {
                if (a.value > b.value)
                    return -1;
                if (a.value < b.value)
                    return 1;
                return 0;
            });
        }
    }
    const needsResponsiveContainer = typeof responsiveContainerWidth === "string" || typeof responsiveContainerHeight === "string";
    return pieChartHasData ? (React.createElement(Tooltip, { content: showPopover ? React.createElement(PopoverContents, { columns: popoverContentsColumns, pieData: data }) : undefined, variant: "table" },
        React.createElement(Box, { "data-testid": "pieChart", width: "100%" },
            React.createElement(ResponsiveContainer, { id: "rechartsPieChartDiv", height: responsiveContainerHeight, width: needsResponsiveContainer ? responsiveContainerWidth : "100%" },
                React.createElement(RechartsPieChart, Object.assign({}, (needsResponsiveContainer
                    ? {}
                    : { height: responsiveContainerHeight, width: responsiveContainerWidth })),
                    React.createElement(Pie, { cursor: cursor, cx: cx, cy: cy, data: data, dataKey: "value", endAngle: endAngle, innerRadius: innerRadius, isAnimationActive: isAnimationActive, nameKey: "name", outerRadius: outerRadius, startAngle: startAngle, stroke: "none" }, data.map((entry, index) => (React.createElement(Cell, { key: `cell-${entry.name}`, fill: entry.fill ||
                            getDataFillColor({
                                entry,
                                index,
                                isRiskChart,
                                theme,
                            }) })))),
                    tooltip,
                    !noLegend && (React.createElement(Legend, { content: (props) => formattedLegendText({ chartColors, props }), wrapperStyle: { left: 0, width: "100%" } }))))))) : (React.createElement(Box, { "data-testid": "rechartsPieChartNoData", style: { height: responsiveContainerHeight, width: responsiveContainerWidth } },
        React.createElement(EmptyChart, { emptyMessage: emptyMessage, emptyMessageFontSize: emptyMessageFontSize })));
};
